import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Edit({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M7.33331 18H5.33331V16L13.5286 7.80474L15.5286 9.80474L7.33331 18Z"
        fill={iconColor}
      />
      <Path
        d="M16.4714 8.86193L14.4714 6.86193L16.3333 5L18.3333 7L16.4714 8.86193Z"
        fill={iconColor}
      />
      <Path
        d="M9.33331 18V17.8856L10.5523 16.6667H18.6666V18H9.33331Z"
        fill={iconColor}
      />
    </Svg>
  );
}
